import React from 'react'
import {CreateGuesser} from '@api-platform/admin'
import {TextInput, NumberInput, SelectArrayInput, ReferenceArrayInput} from 'react-admin';
import {useTranslation} from "react-i18next";


function Create(props) {
    const {t} = useTranslation()

    return (
        <CreateGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <NumberInput source="kpiNumber" label={t('admin.kpiNumber')}/>
            <NumberInput source="foreignId" label={'foreignId'}/>
            <ReferenceArrayInput label={t('admin.efficiencyMetrics')} source="efficiencyMetrics"
                                 reference="dictionary/efficiency_metrics">
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </CreateGuesser>
    )
}

export default Create
